import axios from "axios";
import { Constant } from "../../config";

export default {
  loadMemberCountryList: async (search, page, limit, countryList) => {
    const opt = {
      url: `${Constant.MEMBER_COUNTRY_API}?search=${search}&page=${page}&limit=${limit}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const rtn = resp.data.data;
    const hasData = !!rtn;
    if (!hasData || rtn.length < 1) {
      return resp.data;
    }
    // ? map country
    for (const iter of rtn) {
      const country = countryList.find(
        (c) => c.region_code === iter.region_code
      );
      iter["country_name"] = country["name"];
    }

    // ? asign new data
    resp.data.data = rtn;

    return resp.data;
  },

  submitForm: async (payload) => {
    const opt = {
      url: `${Constant.MEMBER_COUNTRY_API}`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error, result: false };
    }

    return { error: null, result: true };
  },

  submitFormUpdate: async (payload) => {
    const opt = {
      url: `${Constant.MEMBER_COUNTRY_API}/${payload.id}`,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error, result: false };
    }

    return { error: null, result: true };
  },

  allowAggregator: async (payload) => {
    const opt = {
      url: `${Constant.MEMBER_COUNTRY_API}/allow-restricted-cnty`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return { error: resp.data.error, result: false };
    }

    return { error: null, result: true };
  },

  loadMemberCountryLogsList: async (search, page, limit, countryList) => {
    const opt = {
      url: `${Constant.MEMBER_COUNTRY_API}/logs?search=${search}&page=${page}&limit=${limit}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const rtn = resp.data.data;
    const hasData = !!rtn;
    if (!hasData || rtn.length < 1) {
      return resp.data;
    }
    // ? map country
    for (const iter of rtn) {
      const country = countryList.find(
        (c) => c.region_code === iter.region_code
      );
      console.log(country);
      iter["country_name"] = country["name"];
    }

    // ? asign new data
    resp.data.data = rtn;

    return resp.data;
  },

  _loadCountryList: async (search, page, limit, mcList) => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    let rtn = [{ region_code: "NONE", name: "Default" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  },
};



// WEBPACK FOOTER //
// ./src/containers/MemberCountry/service.js